import React from 'react';
import ReactDOM from 'react-dom/client';

export function useConfirm(DialogContent, props) {
    const root = ReactDOM.createRoot(document.createElement('div'))

    return new Promise(res => {
        const confirm = answer => {
            res(answer)
            root.unmount()
        }

        root.render(<DialogContent confirm={confirm} {...props} />)
    })
}

export function useSuccess(DialogContent, props) {
    const root = ReactDOM.createRoot(document.createElement('div'))

    return new Promise(res => {
        const confirm = answer => {
            res(answer)
            root.unmount()
        }

        root.render(<DialogContent confirm={confirm} {...props} />)
    })
}

export function useError(DialogContent, props) {
    const root = ReactDOM.createRoot(document.createElement('div'))

    return new Promise(res => {
        const confirm = answer => {
            res(answer)
            root.unmount()
        }

        root.render(<DialogContent confirm={confirm} {...props} />)
    })
}

export function usePending(DialogContent, prom, props) {
    const root = ReactDOM.createRoot(document.createElement('div'))

    return new Promise((resolve, reject) => {
        let res = () => {
            return prom()
                .then(res => resolve(res))
                .catch(err => reject(err))
                .finally(_ => root.unmount())
        }

        root.render(<DialogContent prom={res} {...props} />)
    })
}